import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { IconType } from "react-icons";

import { map } from "lodash";
import { tripleDot } from "../../helpers/functions";

interface Options {
  id?: string;
  action: string;
  title: string;
  icon?: IconType
}

interface props {
  options: Options[];
  label?: string;
  iconSize?: number;
  Icon?: IconType;
  handleOnClick?: (action: string) => void;
  handleById?: (id?: string) => void;
}

const DropdownActions: React.FC<props> = ({ options, label, iconSize, Icon, handleOnClick, handleById }) => {

  const [toggle, setToggle] = useState<boolean>(false);
  const handleToggle = () => setToggle(!toggle);

  return (
    <Dropdown isOpen={toggle} toggle={handleToggle}>
      <DropdownToggle>
        {label && label}
        {Icon && <Icon size={iconSize || 14} />}
      </DropdownToggle>
      {/* strategy fixed: el menú no queda recortado dentro de tablas con desplazamiento horizontal. */}
      <DropdownMenu strategy="fixed">
        {map(options, (e) => (
          <DropdownItem key={e.id} onClick={() => {
            handleOnClick && handleOnClick(e.action);
            handleById && handleById(e.id);
          }}>
            {e?.icon && <e.icon size={18} />}
            {tripleDot(e.title, 36)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default DropdownActions;